export const getIsSubmitting = state => state.confirmTransfer.get('isSubmitting')
